import moment from "moment";
import { MediaBaseUrl } from "../../../../../../actions/api";
import { Table, OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import ConnectedAccountButton from "./ConnectedAccountButton";
import IconComponent from "../IconComponent";
import $ from 'jquery';
import ProfileImage from "../../../../../CommonComponents/ProfileImage";
import { FontAwesomeIcon } from "../../../../../CommonComponents/AssetsHelper";

const SocialAccountCard = ({ item, deleteSocialAccount }) => {
  const networkIcon = item.Network.name?.toLowerCase().replace(" ", "-");
  const validity = item.ConnectedAccounts.validity ?  moment.unix(item.ConnectedAccounts.validity).format(
    "DD MMM YYYY"
  ) : "--";



  $(document).on('click', '.openSlackButton', function () {
    $('#refresh_posts').on('click', () => {
      $('#refresh_posts').tooltip('hide');
    });
  });

  const isChild = item.ConnectedAccounts.child;

  return (
    <div className="card rounded-0">
      <div className="conn_table connectedAccounts_list">
        <div className="row align-items-center m-0">
          <figure className="col-3 card-header ">
            <div className="d-flex align-items-center flex-nowrap card-title collapsed py-2">
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0 me-3 mt-lg-0 mt-3 d-flex align-items-center">
                  <div className="symbol symbol-30">
                    <img className="img-fluid" src={`${MediaBaseUrl}square-icons/${networkIcon == "twitter" ? networkIcon + "X" : networkIcon}.svg`} alt={item.Network?.name} />
                  </div>
                </div>
                <div className="d-flex flex-column">
                  <p className="font-weight-normal text-dark mb-0 text-nowrap">
                    {item.Network.id == 1 ? 'Twitter(X)': item.Network.id == 2 ? 'Instagram (Insta Login)' : item.Network.id == 18 ?  'Instagram (FB Login)' : item.Network?.name }
                  </p>
                </div>
              </div>
              {isChild && isChild.length > 0 ? (
                <IconComponent class_name={'svg-icon ms-3'} dataToggle="collapse" dataTarget={`#Network_id${item.ConnectedAccounts.id}`} ariaExpanded="false">
                  <FontAwesomeIcon type={'regular'} icon={'chevron-down'} iconClass={'text-gray-500'} />
                </IconComponent>
                // </span>
              ) : (
                ""
              )}
            </div>
          </figure>
          <figure className={`col-${window.location.pathname.includes('connection') ? '3' : '2'}`}>
            <div className="d-flex align-items-center flex-nowrap">
              <div className="flex-shrink-0 me-3 mt-lg-0 mt-3">
                <ProfileImage
                  className={'symbol symbol-circle connected_user_p'}
                  imageSize={35}
                  symbolClass={'symbol-label text-white'}
                  name={item.ConnectedAccounts.accountName} profileUrl={item.ConnectedAccounts.profilePicture} networkId={item.Network.id} color={item.Network.color}/>
              </div>
              <div className="d-flex flex-column">
                <p className="text-dark mb-0">
                  {item.ConnectedAccounts.accountName }
                  {/* Test */}
                </p>
              </div>
            </div>
          </figure>
          <figure className="col-2">
            {validity}
            {/* validity */}
          </figure>
          <figure className="col-2">
            <div className="d-flex align-items-center">
              {item.ConnectedAccounts.api == 4 ? (
                <span className="label font-weight-bold label-xl label-inline label-light-danger acc_status">
                Disconnected
              </span>
              ) : (
                <span className="label font-weight-bold label-xl label-inline label-light-success acc_status">
                  Connected
                </span>
              )}
              {
                item.ConnectedAccounts.api !== 2 &&
                  item.ConnectedAccounts.cronStatus ? (
                  <div className="d-flex mx-2 align-items-center">
                    <IconComponent class_name={''}>
                      <OverlayTrigger overlay={<Tooltip> {item.ConnectedAccounts.cronStatus}</Tooltip>}>
                        <span><FontAwesomeIcon type={'solid'} icon={'circle-info'} iconClass={'fs-5 text-gray-500'} /></span>
                      </OverlayTrigger>
                    </IconComponent>
                  </div>
                ) : (
                  ""
                )
              }
            </div>
          </figure>
          <figure className="col-2">
            {item.ConnectedAccounts.api == 2 ? (
              <>
                {item.Network.id == 4 ? (
                  <ConnectedAccountButton
                    item={item}
                    title={"Refresh"}
                    class_name={"btn btn-primary btn-sm openGoogleButton"}
                  />
                ) : item.Network.id == 20 ||
                  item.Network.id == 24 ||
                  item.Network.id == 10 ? (
                  <ConnectedAccountButton
                    item={item}
                    title={"Refresh"}
                    class_name={"btn btn-primary btn-sm resetAction openSlackButton"}
                  />
                ) : (
                  <ConnectedAccountButton
                    item={item}
                    title={"Refresh"}
                    class_name={"btn btn-primary btn-sm resetAction init"}
                  />
                )}{" "}
              </>
            ) : (
              <>
                {item.Network.id == 4 ? (
                  <ConnectedAccountButton
                    item={item}
                    title={"Reconnect"}
                    class_name={"btn btn-primary btn-sm openGoogleReconnect"}
                  />
                ) : item.Network.id == 20 ||
                  item.Network.id == 24 ||
                  item.Network.id == 10 ? (
                  <ConnectedAccountButton
                    item={item}
                    title={"Reconnect"}
                    class_name={"btn btn-primary btn-sm resetAction openSlackButton"}
                  />
                ) : (
                  <ConnectedAccountButton
                    item={item}
                    title={"Reconnect"}
                    class_name={"btn btn-primary btn-sm resetAction init"}
                  />
                )}
              </>
            )}
          </figure>
          {!window.location.pathname.includes('connection') && <figure className="col-1 text-center">
            <Button variant="link" className="" onClick={deleteSocialAccount(item)}>
              <FontAwesomeIcon type={'regular'} icon={'trash-can'} iconClass={'fs-5 text-secondary'} />
            </Button>
          </figure>}
        </div>
      </div>
      {isChild && isChild.length > 0 ? <>
        <div
          id={`Network_id${item.ConnectedAccounts.id}`}
          className="accordion-collapse collapse"
          data-bs-parent="#connectedAccounts"
        >
          <div className="card-body conn_acc_more">
            <div className="table-responsive">
              <Table className="table table-vertical-center" id="example70046">
                <thead className="bg-gray-100">
                  <tr>
                    <th>#</th>
                    <th>
                      <span>Page profile</span>
                    </th>
                    <th>
                      <span>User Name</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {isChild && isChild.length > 0
                    ? isChild.map((childData, childIndex) => (
                      <tr key={childIndex}>
                        <td>{childIndex + 1}</td>
                        <td>
                          <ProfileImage className={'symbol symbol-circle connected_user_p'}
                            imageSize={35}
                            symbolClass={'symbol-label text-white'}
                            name={childData.ConnectedAccounts.value2} profileUrl={childData.ConnectedAccounts.profilePicture} networkId={childData.Network.id} />
                        </td>
                        <td>
                          <span className="font-weight-bold">
                            {childData.ConnectedAccounts.value2}
                          </span>
                        </td>
                      </tr>
                    ))
                    : ""}
                </tbody>
              </Table>
            </div>
          </div>
        </div> </> : ''}
    </div>
  );
};

export default SocialAccountCard;
